import { render } from "./PbrTrend.vue?vue&type=template&id=a7961abc&scoped=true"
import script from "./PbrTrend.vue?vue&type=script&lang=js"
export * from "./PbrTrend.vue?vue&type=script&lang=js"

import "./PbrTrend.vue?vue&type=style&index=0&id=a7961abc&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7961abc"]])

export default __exports__